import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getUserDataActionAsync } from '../redux/actions/userDataActions'

export const useUser = () => {
  const { userDataState } = useSelector((state: RootState) => state.userData)

  const dispatch = useDispatch()

  const getUserData = () => {
    dispatch(getUserDataActionAsync())
  }

  return { userDataState, getUserData }
}
